import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdcAccordionComponent } from './adc-accordion/adc-accordion.component';
import { AdcAlertComponent } from './adc-alert/adc-alert.component';
import { AdcAutocompleteComponent } from './adc-autocomplete/adc-autocomplete.component';
import { AdcBreadcrumbComponent } from './adc-breadcrumb/adc-breadcrumb.component';
import { AdcCardComponent } from './adc-card/adc-card.component';
import { AdcCarouselComponent } from './adc-carousel/adc-carousel.component';
import { AdcCheckboxComponent } from './adc-checkbox/adc-checkbox.component';
import { AdcDropdownComponent } from './adc-dropdown/adc-dropdown.component';
import { AdcFooterComponent } from './adc-footer/adc-footer.component';
import { AdcHeaderComponent } from './adc-header/adc-header.component';
import { AdcListComponent } from './adc-list/adc-list.component';
import { AdcLoaderComponent } from './adc-loader/adc-loader.component';
import { AdcModalComponent } from './adc-modal/adc-modal.component';
import { AdcPaginationComponent } from './adc-pagination/adc-pagination.component';
import { AdcPanelComponent } from './adc-panel/adc-panel.component';
import { AdcPopoverComponent } from './adc-popover/adc-popover.component';
import { AdcProgressindicatorComponent } from './adc-progressindicator/adc-progressindicator.component';
import { AdcRadiobuttonComponent } from './adc-radiobutton/adc-radiobutton.component';
import { AdcSearchComponent } from './adc-search/adc-search.component';
import { AdcSidenavComponent } from './adc-sidenav/adc-sidenav.component';
import { AdcTabviewComponent } from './adc-tabview/adc-tabview.component';
import { AdcTagComponent } from './adc-tag/adc-tag.component';
import { AdcTextboxComponent } from './adc-textbox/adc-textbox.component';
import { AdcToggleswitchComponent } from './adc-toggleswitch/adc-toggleswitch.component';
import { AdcTooltipComponent } from './adc-tooltip/adc-tooltip.component';
import { AdcTreeviewComponent } from './adc-treeview/adc-treeview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdcButtonComponent } from './adc-button/adc-button.component';
import { RouterModule } from '@angular/router';
import { AdcFormComponent } from './adc-form/adc-form.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { AdcMultiplePanelsComponent } from './adc-multiple-panel/adc-multiple-panel.component';
import * as i2$1 from '@ngx-translate/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AdcTableComponent } from './adc-table/adc-table.component';
import { DateFilterComponent } from './adc-table/date-filter.component';
import { TextFilterComponent } from './adc-table/text-filter.component';
import {MatMenuModule} from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { AdcFileUploadComponent } from './adc-file-upload/adc-file-upload.component';
import { ClickoutsideDirective } from './click-outside.directive';
import { AdcDateTimePickerComponent } from './adc-date-time-picker/adc-date-time-picker.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
// import { NgxMaskModule } from 'ngx-mask';
import { AdcProfileComponent } from './adc-profile/adc-profile.component';
import { AdcColorPickerComponent } from './adc-color-picker/adc-color-picker.component';
import { AdcListViewComponent } from './adc-list-view/adc-list-view.component';
import { ValidateDatePipe } from './adc-list-view/validate-date.pipe';
import { AdcDashboardComponent } from './adc-dashboard/adc-dashboard.component';
import { DropdownPositionDirective } from './dropdown-overlay.directive';
import { AdcFilterComponent } from './adc-filter/adc-filter.component';
import { AdcFilterPopupComponent } from './adc-filter/adc-filter-popup/adc-filter-popup.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const components = [
  AdcAccordionComponent,
  AdcAlertComponent,
  AdcAutocompleteComponent,
  AdcBreadcrumbComponent,
  AdcCardComponent,
  AdcCarouselComponent,
  AdcCheckboxComponent,
  AdcDropdownComponent,
  AdcFooterComponent,
  AdcHeaderComponent,
  AdcListComponent,
  AdcLoaderComponent,
  AdcModalComponent,
  AdcMultiplePanelsComponent,
  AdcPaginationComponent,
  AdcPanelComponent,
  AdcPopoverComponent,
  AdcProgressindicatorComponent,
  AdcRadiobuttonComponent,
  AdcSearchComponent,
  AdcSidenavComponent,
  AdcTabviewComponent,
  AdcTagComponent,
  AdcTextboxComponent,
  AdcTableComponent,
  AdcToggleswitchComponent,
  AdcTooltipComponent,
  AdcTreeviewComponent,
  AdcButtonComponent,
  AdcFormComponent,
  DateFilterComponent,
  TextFilterComponent,
  AdcFileUploadComponent,
  AdcDateTimePickerComponent,
  ClickoutsideDirective,
  AdcProfileComponent,
  AdcColorPickerComponent,
  ValidateDatePipe,
  DropdownPositionDirective,
  AdcListViewComponent,
  AdcDashboardComponent,
  AdcFilterComponent,
  AdcFilterPopupComponent
]

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatTableModule,
    MatButtonModule,
    MatPaginatorModule,
    MatIconModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMatTimepickerModule,
    MatDatepickerModule,
    MatInputModule,
    // NgxMaskModule.forRoot()
  ],
  exports: [
    ...components,
  ]
})
export class AdcComponentsModule { }
